<div class="form-group">
    <div class="row fields-group">
        <div class="col-md-4 col-4">
            <label class="input-label">{{ 'dets.predicate' | translate }}</label>
            <select class="form-control"
                    [(ngModel)]="operator"
                    (ngModelChange)="operatorValueChanged()">
        <option *ngFor="let o of operators" [ngValue]="o">{{ o | translate }}</option>
      </select>
        </div>
        <div class="col-md-8 col-8">
            <label class="input-label">{{ 'dets.predicate_value' |
        translate }}</label>
            <input class="form-control"
                   type="number"
                   min="0.00"
                   step="0.01"
                   name="moneyValue"
                   [(ngModel)]="moneyValue"
                   (ngModelChange)="moneyValueChanged($event)">
            
            <label class="input-label mt-2">{{ 'dets.comparison_field_label' | translate }}</label>
            <search-select *ngIf="fields.length > 0"
                    (change)="onTargetFormFieldKeyChange($event)"
                    [items]="fields"
                    [selected]="sourceFormFieldKey"
                    [placeholder]="'Choose here' | translate"></search-select>
        </div>
    </div>
</div>
